import React from "react";
import { useNavigate } from "react-router";

const Product = ({ item, url }) => {
  const navigate = useNavigate();
  const moveToPage = (prdNo) => {
    navigate(`/shop/${url}/productsView/${prdNo}`);
  };

  return (
    <li key={item.id} onClick={() => moveToPage(item.id)}>
      <div className="image">
        <img src={imgHandler(item.media)} onError={onErrorImg} />
      </div>
      <div className="info">
        <span className="name">{item?.name ? item.name : ""}</span>
        <span className="price">{item?.price ? `${formatNumber(item.price)}원` : "가격 문의"}</span>
      </div>
    </li>
  );
};

export default Product;
